/**
 * Main Modules
 */
export const DASHBOARD = 'Dashboard';
export const PARTIES = 'Parties';
export const INVENTORY = 'Inventory';
export const PURCHASES = 'Purchases';
export const SALES = 'Sales';
export const PRODUCTION = 'Production';
export const FINANCIALS = 'Financials';
export const PRODUCT = 'Product';
export const SETTINGS = 'Settings';
export const REPORT = 'Report';
export const COLLECTION = 'Collection';

/**
 * @ desc Sub Modules
 */
/************************* Parties ********************/
export const RoleParties = 'All';

/************************* Tripta-Amount ********************/
export const RoleCollection = 'Collection';

/************************* Dashboard ********************/
export const RoleAdminDashboard = 'Admin Dashboard';
export const RoleSalesDashboard = 'Sales Dashboard';
export const RoleOldCustFollowUps = 'Old Customer Follow-Ups';

/************************* Inventory ********************/
export const RoleConsumptionDashboard = 'Consumption Dashboard';
export const RoleStockRawMaterial = 'Stock(Raw Material)';
export const RoleStockConsumptionRawMaterial =
  'Stock Consumption(Raw Material)';
export const RoleStockTransferRawMaterial = 'Stock Transfer(Raw Material)';

/************************* Purchases ********************/
export const RolePurchaseDashboard = 'Purchase Dashboard';
export const RolePurchaseOrder = 'Purchase Order';
export const RolePurchaseOrderOperator = 'Purchase Order Operator';
export const RolePurchaseEntry = 'Purchase Entry';
export const RolePrePrinted = 'Pre-Printed P.O. Status';
export const RolePpPriceHistory = 'PP Price History';
export const RoleNLRequirement = 'NL Requirement';

/************************* Sales ********************/
export const RoleOrders = 'Orders';
export const RoleOrdersOperator = 'Order Operator';
export const RoleProformaInvoice = 'Pro-forma Invoice';
export const RoleTaxInvoice = 'Tax Invoice';
export const RoleThumbnail = 'Thumbnail';

/************************* Production ********************/
export const RoleMFGLive = 'MFG Live';
export const RoleMachineJobQueue = 'Machine Job Queue';
export const RoleMachineJobQueueOperator = 'Machine Job Queue Operator';
// export const RoleMFGOperator = 'Mfg operator';
export const RoleMFGOperator = 'MFG Live Operator';

/************************* Financials ********************/
export const RoleProfitAnalysis = 'Profit Analysis';
export const RoleCollectionSMS = 'Collection SMS';
export const RoleBrokerMargin = 'Broker margin';

/************************* Product ********************/
export const RoleTrendingProductsBagConsumption =
  'Trending Products & Bag Tag Consumption';
export const RoleBags = 'Bags';
export const RoleProducts = 'Products';
export const RoleProductTransfer = 'Product Transfer';
export const RoleMobileAppPriceList = 'Mobile App Rate List';

/************************* Report ********************/
export const RoleRawMaterial = 'Raw Material';
export const RoleFinishedGoods = 'Finished Goods';
export const RolePendingJobs = 'Pending Jobs';
export const RoleFinance = 'Finance';
export const RolesSales = 'Sales';
export const RolePurchase = 'Purchase';
export const RoleMonthlyTurnover = 'Monthly Turnover';
export const RoleDesigner = 'Designer';

/************************* Settings ********************/
export const RoleCompany = 'Company';
export const RoleUsers = 'Users';
export const RoleItemsRawMaterials = 'Items(Raw Materials)';
export const RoleMiscMasters = 'Misc Masters';
export const RolesPermissions = 'Roles & Permissions';
export const RoleOther = 'Other';
export const RoleGeneralConfiguration = 'General Configuration';
